import * as React from 'react';
import SkillKeyValueConfigComponent from './SkillKeyValueConfigComponent';
import { Control, useFieldArray, UseFormRegister } from 'react-hook-form';
import { SkillForm } from './AgentSkillsComponent';
import { useTranslate } from 'sbx-crm-menu-ui';

type Props = {
    control: Control<SkillForm>
    register: UseFormRegister<SkillForm>
};
const SkillRequestComponent = ({control, register}: Props) => {
    const { t: agent } = useTranslate('agent');
    const { t: common } = useTranslate('common');

    const requestParams = useFieldArray({
        name: 'new_skill.config.params',
        control,
    });

    const requestHeaders = useFieldArray({
        name: 'new_skill.config.headers',
        control,
    });

    return (
        <>
            <SkillKeyValueConfigComponent label={agent('params')}
                                          placeholderKey={common('name')}
                                          placeholderValue={common('description')}
                                          append={() => {
                                              requestParams.append({
                                                  name: '',
                                                  value: '',
                                              });
                                          }}
                                          name={'params'}
                                          buttonLabel={`${common('add')} ${agent('params')}`}
                                          formArray={requestParams} register={register} />

            <SkillKeyValueConfigComponent label={agent('headers')}
                                          append={() => {
                                              requestHeaders.append({
                                                  name: '',
                                                  value: '',
                                              });
                                          }}
                                          name={'headers'}
                                          buttonLabel={`${common('add')} ${agent('headers')}`}
                                          formArray={requestHeaders} register={register} />
        </>
    );
};

export default SkillRequestComponent;